export class ResetPasswordViewModel {
  email: string = '';
  verificationCode: string = '';
  password: string = '';
  confirmPassword: string = '';
}
